//import { useState, useRef } from "react";
import DashboardLayout from "components/templates/DashboardLayout";
import Topnav from "components/organisms/Topnav";
//import Grid from "@mui/material/Grid";
import React from "react";
import { Grid, Row, Col } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import TablePanel from "pages/dashboard/Components/TablePanel";
import MDBox from "components/atoms/MDBox";

function ShowDashboard() {
  return (
    <DashboardLayout>
      <Topnav title={"DASHBOARD"} />
      <MDBox mb={4} />
      <Grid fluid>
        <Row gutter={[9, 24]}>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 1"}
              collectionName={"sstd1comb"}
              backgroundColor="#0F9ED5"
            />
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 2"}
              collectionName={"sstd2comb"}
              backgroundColor="#4EA72E"
            />
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 3"}
              collectionName={"sstd3comb"}
              backgroundColor="#0F9ED5"
            />
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 4"}
              collectionName={"sstd4comb"}
              backgroundColor="#4EA72E"
            />
          </Col>
        </Row>
      </Grid>
    </DashboardLayout>
  );
}

export default ShowDashboard;
